import types from "../actions/actionTypes";
import initialState from "./initialState";

export default function sidebarNavItemsReducer(state = initialState.sidebarNavItems, action) {

    const filterOutUnauthorisedItems = (items, loggedInUserDetails) => {
        if (!Array.isArray(items)) {
            return items;
        }
        if (items.length < 1) {
            return [];
        }

        return items.filter(item => isVisible(item, loggedInUserDetails))
            .map(item => filterOutUnauthorisedChildren(item, loggedInUserDetails));
    };

    const filterOutUnauthorisedChildren = (item, loggedInUserDetails) => {
        const newItem = { ...item, _children: filterOutUnauthorisedItems(item._children, loggedInUserDetails) };
        return newItem;
    };

    const isVisible = (item, loggedInUserDetails) => {

        if (!Array.isArray(item.roles)) {
            return true;
        }

        const rolesRequiredCount = item.roles.length;

        if (rolesRequiredCount < 1) {
            return true;
        }

        for (var i = 0; i < rolesRequiredCount; i++) {
            if (loggedInUserDetails.roles.includes(item.roles[i])) {
                return true;
            }
        }
        return false;
    };

    const getNavItems = (state, loggedInUserDetails) => {
        const newState = filterOutUnauthorisedItems(state, loggedInUserDetails);
        return newState;
    };

    switch (action.type) {
        case types.UPDATE_NAV_AFTER_LOGIN_DETAILS_SUCCESS:
            return getNavItems(state, action.loggedInUserDetails);
        default:
            return state;
    }
}
